// import { redis } from '@/api'
// import axios from 'axios'
// axios.defaults.headers.post['Content-Type'] = 'text/xml; charset=utf-8'
import { loginOut } from '../../utils/common'
const user = {
    state: {
        crumbList: [], // 面包屑导航
        setuser: "",
        isSave: false,  // 控制 EstablishProduct
        isCacheConmmodity: false,  // 控制 conmmoditySummary
        role: {},
        token: '',
        TimeoutTimerId: null, //token超时的定时器id
    },
    mutations: {
        // 添加面包屑导航
        setCrumbList(state, route) {
            if (state.crumbList.length) {
                // console.log(state.crumbList)
                const arr = state.crumbList.map(item => item.path);
                // console.log(arr.indexOf(route.path))
                if (arr.indexOf(route.path) == -1) {
                    // console.log(route)
                    state.crumbList.push(route);
                }
            } else {
                state.crumbList.push(route);
            }
        },
        setRole(state, route) {
            state.role = route;
        },
        setToken(state, route) {
            state.token = route;
        },
        setTimeoutTimerId(state, route) {
            state.TimeoutTimerId = route;
        },
        loginOut(state){
            loginOut();
            state.role = {};
            state.crumbList = [];
            localStorage.removeItem('data')
            localStorage.removeItem('role')
            localStorage.removeItem('sellerInfo');
            localStorage.removeItem("loginTime");

            localStorage.removeItem('token');

            localStorage.setItem('isRefresh', '1')
            if (state.TimeoutTimerId){
                clearTimeout(state.TimeoutTimerId);
                state.TimeoutTimerId = null;
            }
            sessionStorage.clear();
        },
        // 删除面包屑导航
        delCrumbList(state, routeName) {
            // console.log(routeName)
            if (state.crumbList.length) {
                const arr = state.crumbList.map(item => item.path);
                state.crumbList.splice(arr.indexOf(routeName), 1);
            }
        },
        // 清空面包屑导航
        clearCrumbList(state) {
            state.crumbList = [];
            const param = {
                meta: { title: " 首页", isClose: true },
                name: "/box/Thome",
                path: "/box/Thome",
            };
            state.crumbList.push(param);
        },
        // token
        set_token(state, token) {
            state.token = token;
            localStorage.token = token;
        },
        del_token(state) {
            state.token = "";
            localStorage.removeItem("token");
        },
        set_cookie(state, cookie) {
            state.cookie = cookie;
            localStorage.cookie = cookie;
        },
        set_user(state, route) {
            state.setuser = route;
            localStorage.setItem("user", JSON.stringify(route));
        },
        SET_IS_CACHE_CONMMODITY(state, val) {
            state.isCacheConmmodity = val
        }
    },
    actions: {
        setCrumbList({ commit }, route) {
            commit("setCrumbList", route);
        },
        delCrumbList({ commit }, route) {
            commit("delCrumbList", route);
        },
        set_token({ commit }, route) {
            commit("set_token", route);
        },
        set_cookie({ commit }, route) {
            commit("set_cookie", route);
        },
        set_user({ commit }, route) {
            commit("set_user", route);
        },
    },
};

export default user;
